import { useCallback, useEffect, useState } from 'react'
import { rentalTechService } from '../../services/api'

export const useRentalTechData = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState({
    dashboard: {},
    equipments: [],
    orders: [],
    availability: [],
    maintenance: [],
    telemetry: []
  })

  const refresh = useCallback(async () => {
    setLoading(true)
    try {
      const [dashboardRes, equipmentRes, ordersRes, availabilityRes, maintenanceRes, telemetryRes] = await Promise.all([
        rentalTechService.getDashboard(),
        rentalTechService.getEquipments(),
        rentalTechService.getOrders(),
        rentalTechService.getAvailability(),
        rentalTechService.getMaintenance(),
        rentalTechService.getTelemetry()
      ])

      setData({
        dashboard: dashboardRes?.data?.data || {},
        equipments: equipmentRes?.data?.data || [],
        orders: ordersRes?.data?.data || [],
        availability: availabilityRes?.data?.data || [],
        maintenance: maintenanceRes?.data?.data || [],
        telemetry: telemetryRes?.data?.data || []
      })
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    refresh()
  }, [refresh])

  return { ...data, loading, refresh }
}

export const equipmentOptions = (equipments) => (equipments || []).map((item) => ({
  value: item.id,
  label: `${item.code || 'EQ'} - ${item.name}`
}))

export const findEquipmentById = (equipments, id) => (equipments || []).find((item) => item.id === id)
